import I18n from 'I18n';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Button } from 'foundations-components/transitional/components/Button';
import useCrmObjectTypeListingFilters from 'framework-listing-lib/hooks/useCrmObjectTypeListingFilters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NoResultsIllustration = () => /*#__PURE__*/_jsx(Illustration, {
  name: "empty-state-charts",
  alt: I18n.text('noResultsMessage'),
  marginBlockEnd: "200"
});
const PrimaryContent = ({
  onClickResetLink = () => {}
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.state.emptyState.noFormsSearchExplanation"
    })
  }), /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(Button, {
      use: "link",
      onClick: onClickResetLink,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dashboard.state.emptyState.clearSearch"
      })
    })
  })]
});
const EmptyStateFolder = () => {
  const {
    onClearFilters
  } = useCrmObjectTypeListingFilters();
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "FORMS_DASHBOARD_NO_RESULTS",
    children: /*#__PURE__*/_jsx(EmptyState, {
      id: "forms-dashboard-no-results",
      "data-test-id": "forms-dashboard-no-results",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dashboard.state.emptyState.noFormsMatchThisSearch"
      }),
      primaryContent: /*#__PURE__*/_jsx(PrimaryContent, {
        onClickResetLink: onClearFilters
      }),
      secondaryContent: /*#__PURE__*/_jsx(NoResultsIllustration, {}),
      secondaryContentWidth: 200
    })
  });
};
export default EmptyStateFolder;